import Bottom from 'layouts/Bottom';
import Header from 'layouts/Header';
import Form from './Form';

const Home = () => {
  return (
    <>
      <Header />
      <div className='contain_center main_up_data'>
        <Form />
      </div>
      <Bottom />
    </>
  );
};

export default Home;
